import { Modal } from "react-bootstrap";
import ReactPlayer from "react-player";

import zero from "../../asset/videos/EasternProvince.mp4";
import one from "../../asset/videos/NorthernBorders.mp4";
import two from "../../asset/videos/aljouf.mp4";
import three from "../../asset/videos/Najran.mp4";
import four from "../../asset/videos/Aseer.mp4";
import five from "../../asset/videos/jazan.mp4";
import six from "../../asset/videos/tabok.mp4";
import seven from "../../asset/videos/Medina.mp4";
import eight from "../../asset/videos/makah.mp4";
import nine from "../../asset/videos/riyadh.mp4";
import ten from "../../asset/videos/Qassim.mp4";
import eleven from "../../asset/videos/Hail.mp4";
import twilve from "../../asset/videos/Al-Bahah.mp4";

function Video(props) {
  //Here is the videos
  let videos = [
    zero,
    one,
    two,
    three,
    four,
    five,
    six,
    seven,
    eight,
    nine,
    ten,
    eleven,
    twilve,
  ];

  return (
    <div>
      <Modal show={props.show} onHide={props.close} fullscreen={true}>
        <Modal.Body
          className="d-flex align-items-center justify-content-center flex-column bg-black"
          onClick={() => {
            props.close();
          }}
        >
          <ReactPlayer
            id="hello"
            url={videos[props.data]}
            width="100%"
            height="100%"
            volume="0.3"
            onEnded={props.close}
            onPause={props.close}
            playing={true}
          />
        </Modal.Body>
      </Modal>
    </div>
  );
}

export default Video;
